// @format
import axios from 'axios';
import { getToken } from '../config/auth';

/*
 * Cria um instância do axios com o nome api e define
 * uma URL padrão.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

/*
 * Adiciona um interceptor com o header de autorização,
 * desta forma cada request enviará as credenciais
 * do usuário.
 */

api.interceptors.request.use(
  async config => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export default api;
